export default "__VITE_ASSET__7f92df84__"